import React, { useEffect } from 'react';
import { useQueryClient } from 'react-query';

// item 326 — the "real-time" heartbeat: invalidate the dashboard's source list
// queries on an interval so every mounted consumer (KPI strip, bento, live page)
// refetches and the numbers visibly move as work processes across the org. The
// app is REST-only (no push channel), so this is honest fast polling — paused
// while the tab is hidden so background tabs don't hammer the API.
const DASHBOARD_QUERY_KEYS = ['proposals', 'workOrders', 'invoices', 'projects', 'recurringRevenue'];

const LiveDataPulse: React.FC<{ intervalMs: number }> = ({ intervalMs }) => {
  const queryClient = useQueryClient();
  useEffect(() => {
    const id = window.setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      DASHBOARD_QUERY_KEYS.forEach((k) => queryClient.invalidateQueries(k));
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [queryClient, intervalMs]);
  return null;
};

export default LiveDataPulse;
